import type { AnalysisParameters } from '../types';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './pilot-ui/table';

export default function AnalysisParametersTable({ params, overrides = {} }:
  { params: AnalysisParameters; overrides?: AnalysisParameters }) {
  return (
    <Table aria-label="Effective analysis parameters">
      <TableHeader><TableRow><TableHead>Parameter</TableHead><TableHead>Effective value</TableHead><TableHead>Override</TableHead></TableRow></TableHeader>
      <TableBody>{Object.entries(params).map(([key, value]) => (
        <TableRow key={key}><TableCell className="font-mono">{key}</TableCell><TableCell>{JSON.stringify(value)}</TableCell>
          <TableCell>{Object.hasOwn(overrides, key) ? 'Overridden' : 'Default'}</TableCell></TableRow>
      ))}</TableBody>
    </Table>
  );
}
